/** "$3" for whole dollars, "$0.28" otherwise — for per-million token rates. */
export function formatPerMillion(dollars: number): string {
  const fixed = dollars.toFixed(2)
  return `$${dollars >= 1 ? fixed.replace(/\.00$/, '') : fixed}`
}

/** Always two decimals — for worked billing examples. */
export function formatUsd(dollars: number): string {
  return `$${dollars.toFixed(2)}`
}
